import React from 'react';
import { Button } from './ui/button';
import { ArrowRight, Shield } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL;
const HERO_IMG = `${API}/api/cars/images/10d600b6-3aba-4df6-a0d7-e330f788c7ff.webp`;

const HeroSection = () => {
  const scrollToQuote = () => {
    const element = document.getElementById('quote');
    if (element) element.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <section className="relative h-screen min-h-[600px] flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <img
        src={HERO_IMG}
        alt="Shanghai RunTheRays International Trade"
        className="absolute inset-0 w-full h-full object-cover"
        fetchpriority="high"
      />

      {/* Dark Overlay */}
      <div className="absolute inset-0 bg-gradient-to-r from-blue-900/90 via-blue-900/80 to-blue-900/70"></div>

      {/* Content */}
      <div className="relative z-10 container mx-auto px-4 sm:px-6 lg:px-8 text-white">
        <div className="max-w-4xl">
          <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold mb-6 leading-tight">
            Global Trade Made
            <span className="block text-orange-500">Simple. Reliable. Transparent.</span>
          </h1>
          <p className="text-xl md:text-2xl mb-8 text-gray-200 max-w-2xl">
            Since 2019, empowering businesses worldwide to trade confidently with China.
          </p>
          <div className="flex flex-col sm:flex-row gap-4">
            <Button
              onClick={scrollToQuote}
              size="lg"
              className="bg-orange-600 hover:bg-orange-700 text-white font-semibold px-8 py-6 text-lg transition-all duration-300 hover:scale-105"
              data-testid="hero-cta-quote"
            >
              Get a Free Sourcing Quote
              <ArrowRight className="ml-2 h-5 w-5" />
            </Button>
            <Button
              onClick={scrollToQuote}
              size="lg"
              variant="outline"
              className="border-2 border-white text-white hover:bg-white hover:text-blue-900 font-semibold px-8 py-6 text-lg transition-all duration-300"
              data-testid="hero-cta-verify"
            >
              <Shield className="mr-2 h-5 w-5" />
              Verify Your Supplier
            </Button>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-10">
        <div className="animate-bounce">
          <div className="w-6 h-10 border-2 border-white rounded-full flex items-start justify-center p-2">
            <div className="w-1 h-3 bg-white rounded-full"></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
